<main>
  <mat-card>
    <mat-card-title>{{ "MOBILE_APP.MY_APPOINTMENTS.TITLE" | translate }}</mat-card-title>
        <div>{{title}}</div>
        <div>{{ "MOBILE_APP.MY_APPOINTMENTS.OBJECT" | translate }} {{object}}</div>
        <div>{{ "MOBILE_APP.MY_APPOINTMENTS.CREATED_BY" | translate }} <strong>{{createdBy}}</strong></div>
        <div *ngIf="location">{{ "MOBILE_APP.MY_APPOINTMENTS.LOCATION" | translate }} {{location}}</div>
    <mat-dialog-actions>
        <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.close' | translate"></button>
      </mat-dialog-actions>
  </mat-card>
</main>